/**
 * Класс IdentifyResult используемый для возврата результата идентификации объектов слоя.
 */
class IdentifyResult {
  /**
   * Создает экземпляр класса IdentifyResult
   */
  constructor(params) {
    this.layerId = params.layerId;
    this.layerName = params.layerName;
    this.queryGeometry = params.queryGeometry;
    this.attributes = params.attributes;
    this.geometry = params.geometry;
    this.preparedAttributes = params.preparedAttributes;
    this.dirtyData = params.dirtyData;
    this.score = params.score;
    this.title = params.title;
  }
}

module.exports = IdentifyResult;